export default __webpack_public_path__ + "static/media/character-bear-sad.3d83398c.png";